var poll_default = {
  "fontElementMap": "_5yd2p",
  "container": "u-2Mk",
  "fullscreen": "_0G8Wf",
  "background_overlay": "dpUNr",
  "with_image": "_6v3dV",
  "options": "-mQFW",
  "webview": "_3l5b7",
  "grid": "_3tlHA",
  "option": "pD-C1",
  "cta_button": "_0fzAH",
  "add_option": "PGscS",
  "see_more": "_5jOQo",
  "list": "zcQow",
  "column": "iGxpY",
  "additional_note": "_7iZ8B",
  "spinner": "uKVb1",
  "spin": "icW-9",
  "shown": "APpKv",
  "error": "MYADP"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
